import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["href", "overlay", "dropdownProps", "children", "clsPrefix", "separator", "active"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../../wui-dropdown/src/index';
import Icon from '../../wui-icon/src/index';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  /**
   * 如果设置成true渲染`span` 而不是 `a`
   */
  active: PropTypes.bool,

  /**
   * `href` a标签href
   */
  href: PropTypes.string,

  /**
   * `title`  标签title属性
   */
  title: PropTypes.node,
  separator: PropTypes.string,
  clsPrefix: PropTypes.string,
  overlay: PropTypes.element,
  dropdownProps: PropTypes.object
};
var defaultProps = {
  active: false,
  separator: '/',
  dropdownProps: {}
};
var BreadcrumbItem = (_dec = WebUI({
  name: "breadcrumb",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(BreadcrumbItem, _React$Component);

  var _super = _createSuper(BreadcrumbItem);

  function BreadcrumbItem() {
    var _this;

    _classCallCheck(this, BreadcrumbItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props = _this.props,
          href = _this$props.href,
          overlay = _this$props.overlay,
          dropdownProps = _this$props.dropdownProps,
          children = _this$props.children,
          clsPrefix = _this$props.clsPrefix,
          separator = _this$props.separator,
          active = _this$props.active,
          props = _objectWithoutProperties(_this$props, _excluded); // 如果包含href值，则


      var content = href ? /*#__PURE__*/React.createElement("a", _extends({}, props, {
        href: href
      }), children) : /*#__PURE__*/React.createElement("span", props, children);
      return overlay && /*#__PURE__*/React.isValidElement(overlay) ? /*#__PURE__*/React.createElement(Dropdown, _extends({}, dropdownProps, {
        overlay: overlay,
        className: "".concat(clsPrefix, "-overlay")
      }), /*#__PURE__*/React.createElement("span", props, children, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-arrow-down"
      }))) : content;
    });

    return _this;
  }

  _createClass(BreadcrumbItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          active = _this$props2.active,
          className = _this$props2.className,
          separator = _this$props2.separator,
          clsPrefix = _this$props2.clsPrefix;
      return /*#__PURE__*/React.createElement("li", {
        className: classNames(className, {
          active: active
        })
      }, this.renderContent(), /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-separator")
      }, separator));
    }
  }]);

  return BreadcrumbItem;
}(React.Component)) || _class);
BreadcrumbItem.propTypes = propTypes;
export default BreadcrumbItem;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-breadcrumb/src/BreadcrumbItem.js